import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const defaultState = {
  characterList: [],
  totalCount: 0,
  totalPageCount: 0,
  pageNo: 1,
  pageSize: 15,
  sortType: 0,
  // character data structure example
  // "gid" : "1276",
  // "worldId" : "CROA",
  // "worldName" : "크로아",
  // "gcid" : "CROA:2772693258459218076",
  // "gcName" : "완전똥망겜"
  // "gsid" : 1
  selectedCharacter: {}
}

export default {
  namespaced: true,
  state: defaultState,
  actions,
  getters,
  mutations
}
